import { DateModuleSubtypeResponse, DateSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/dateSubtype";

interface DateSubtypeSummaryProps {
    subtype: DateModuleSubtypeResponse;
    subtypeData: DateSubtypeDataModel;
}

export default function DateSubtypeSummary(props: DateSubtypeSummaryProps) {
    if (!props.subtypeData.selectedDate) {
        return <>-</>;
    }

    const date = new Date(props.subtypeData.selectedDate);

    return (
        <>
            {isNaN(date.getTime())
                ? "-"
                : date.toLocaleDateString()}
        </>
    );
}